import { useEffect, useState } from "react";
import { TableTundish } from "./components/DataTable/TableTundish";
import { useTundishHMContext } from "./context/TundishHeatMetricContext";
import { getTundishes } from "./repositories/TundishHMRepository";

export const TundishHeatMetricsPage = () => {
	const { state, actions } = useTundishHMContext();
	const [isLoading, setIsLoading] = useState(true);
	const [showErrorModal, setShowErrorModal] = useState(false);
	const [fetchDataError, setFetchDataError] = useState<string | null>(null);

	const getTundishesFromAPI = async () => {
		setIsLoading(true);
		try {
			const { tundishes, ok } = await getTundishes();
			if (ok) {
				actions.setTundishes(tundishes);
				setIsLoading(false);
			}
		} catch (error) {
			setFetchDataError(error as string);
			setShowErrorModal(true);
		}
	};

	useEffect(() => {
		getTundishesFromAPI();
	}, []);
	return (
		<div>
			<TableTundish
				isLoading={isLoading}
				getTundishesFromAPI={getTundishesFromAPI}
			/>
		</div>
	);
};
